import gameConsts from './gameConsts';
import RoadObject from './RoadObject';

const DELTA_POINTS = 150;

export default class Bonus extends RoadObject {
  constructor({ game, player, values, road, name }) {
    super({
      game,
      player,
      values,
      road,
      name,
    });
  }
  get _minX() {
    return this._road.item.position.x + this._road.borderWidth;
  }
  get _maxX() {
    return (this._road.width + this._road.item.position.x) - (this.width + this._road.borderWidth);
  }
  _setArea() {
    this.item.body.setSize(this._defaultWidth, this.defaultHeight, 0, this._bodyOffsetY);
  }
  _take() {
    // прибавляем очки, удаляем иконку с дороги
    this._playerData.points += this._playerData.pointsMultipler * DELTA_POINTS;
    this.item.y = gameConsts.GAME_HEIGHT;
    this.isActive = false;
  }
  _setRandomX() {
    this.item.x = (Math.random() * (this._maxX - this._minX)) + this._minX;
  }
  create() {
    super.create();
    this.item.bringToTop();
  }
  update() {
    if (this.isActive) {
      this._move();
      // соприкоснование машинки с иконкой
      this._game.physics.arcade.collide(this._player.item, this.item, this._take, null, this);
      this._checkOutScreen();
    } else {
      this._activate('bonus');
    }
  }
}




// WEBPACK FOOTER //
// ./src/js/Bonus.js